import { render, staticRenderFns } from "./TopLikedPosts.vue?vue&type=template&id=38a8869a&"
import script from "./TopLikedPosts.vue?vue&type=script&lang=js&"
export * from "./TopLikedPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports